/*
  Shreya — <deal-countdown> live clock.
  Used by the Countdown section and by product sliders with a sale timer.

  <deal-countdown data-end="UNIX_SECONDS" data-expire="message|hide|zeros">
    <span data-unit="days">00</span> … <span data-unit="seconds">00</span>
  </deal-countdown>
  A sibling/ancestor [data-countdown-scope] receives .is-expired when the clock reaches zero,
  and [data-countdown-message] inside that scope is revealed when data-expire="message".
*/
(() => {
  if (customElements.get('deal-countdown')) return;

  const SECOND = 1000;
  const twoDigits = (n) => (n < 10 ? `0${n}` : String(n));

  const split = (ms) => {
    const total = Math.floor(ms / SECOND);
    return {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
  };

  class DealCountdown extends HTMLElement {
    connectedCallback() {
      this.endsAt = Number(this.dataset.end || 0) * SECOND;
      if (!this.endsAt) return;
      this.digits = {};
      this.querySelectorAll('[data-unit]').forEach((el) => { this.digits[el.dataset.unit] = el; });
      this.render();
      this.interval = window.setInterval(() => this.render(), SECOND);
      this.onVisible = () => { if (!document.hidden) this.render(); };
      document.addEventListener('visibilitychange', this.onVisible);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
      if (this.onVisible) document.removeEventListener('visibilitychange', this.onVisible);
    }

    render() {
      const remaining = Math.max(0, this.endsAt - Date.now());
      const parts = split(remaining);
      Object.keys(parts).forEach((unit) => {
        const el = this.digits[unit];
        if (!el) return;
        const next = twoDigits(parts[unit]);
        if (el.textContent === next) return;
        el.textContent = next;
        // retrigger the small "tick" animation
        el.classList.remove('is-ticking');
        void el.offsetWidth;
        el.classList.add('is-ticking');
      });
      if (remaining === 0) this.complete();
    }

    complete() {
      window.clearInterval(this.interval);
      if (this.hasAttribute('data-complete')) return;
      this.setAttribute('data-complete', '');

      const scope = this.closest('[data-countdown-scope]') || this.parentElement;
      const mode = this.dataset.expire || 'zeros';
      if (scope) scope.classList.add('is-expired');

      if (mode === 'message' || mode === 'hide') {
        const note = scope && scope.querySelector('[data-countdown-message]');
        if (note) {
          note.hidden = false;
          this.hidden = true;
        }
      }
      // Never hide while the merchant is editing, they still need to reach the settings.
      if (mode === 'hide' && !(window.Shopify && window.Shopify.designMode)) {
        const section = this.closest('.shopify-section');
        if (section) section.hidden = true;
      }
      this.dispatchEvent(new CustomEvent('countdown:complete', { bubbles: true }));
    }
  }

  customElements.define('deal-countdown', DealCountdown);
})();
